import { render } from "./UserPreference.vue?vue&type=template&id=6215e51d&scoped=true&ts=true"
import script from "./UserPreference.vue?vue&type=script&lang=ts"
export * from "./UserPreference.vue?vue&type=script&lang=ts"

import "./UserPreference.vue?vue&type=style&index=0&id=6215e51d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6215e51d"]])

export default __exports__